import { StandortResult } from '@/domain/navigation/features/search/types/resultItem';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function StandortResultItem({
  standort,
  handleClose,
}: {
  standort: StandortResult;
  handleClose: (value: boolean) => void;
}) {
  const { updateStandort, standorte } = useStandortContext();

  return (
    <div
      onClick={() => {
        const destinationStandort = standorte.find((s) => s.id === standort.id);
        if (destinationStandort) updateStandort(destinationStandort);
        handleClose(false);
      }}
      data-show-second-badge="false"
      data-variante="Standort"
      className="w-72 px-2 py-3 inline-flex flex-col justify-center items-start cursor-pointer">
      <div className="self-stretch inline-flex justify-start items-center gap-3">
        <div className="w-8 h-8 flex justify-center items-center">
          <FontAwesomeIcon icon={faLocationDot} size="xl" />
        </div>
        <div className="w-44 h-5 justify-start text-neutrals-900 text-sm font-normal leading-tight">
          {standort.name}
        </div>
      </div>
    </div>
  );
}
